import { mapState } from 'vuex';
export default {
  name: 'MonitoringEnableDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState('app', ['color']),
    internalOpen: {
      get() {
        return this.open;
      },
      set(val) {
        if (!val) {
          this.$emit('close');
        }
      }
    },
    hasExistingConfig() {
      var _this$config$properti;
      return this.config && ((_this$config$properti = this.config.properties) === null || _this$config$properti === void 0 || (_this$config$properti = _this$config$properti.metadata) === null || _this$config$properti === void 0 ? void 0 : _this$config$properti.lastDeactivatedAt);
    },
    lastDeactivatedDate() {
      if (!this.hasExistingConfig) {
        return '';
      }
      const date = new Date(this.config.properties.metadata.lastDeactivatedAt);
      return date.toLocaleString();
    }
  },
  methods: {
    confirm(reuseExisting) {
      this.$emit('confirm', reuseExisting);
    },
    cancel() {
      this.$emit('close');
    }
  }
};